// extracted by mini-css-extract-plugin
export default {"partnerPage":"PartnerPageStyle_partnerPage__1ByCd","bgColor":"PartnerPageStyle_bgColor__X94+A"};